import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand" style={{ marginTop: "-40px" }}>
          <img
            src={logo} alt="EcoConnect"
            style={{ height: "130px", width: "320px", objectFit: "contain", filter: "brightness(0) invert(1)", display: "block", marginBottom: "-30px" }}
          />
          <p style={{ marginTop: "0" }}>
            India's AI-powered energy ecosystem platform — connecting EV, Solar,
            IoT and sustainable infrastructure for a greener tomorrow.
          </p>

          {/* ✅ Corporate Website Link */}
          <a
            href="https://www.ecoconnectservices.com/"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "inline-flex", alignItems: "center", gap: "8px",
              marginTop: "12px", marginBottom: "16px",
              background: "rgba(255,255,255,0.07)",
              border: "1px solid rgba(255,255,255,0.15)",
              borderRadius: "8px", padding: "8px 16px",
              color: "rgba(255,255,255,0.75)", textDecoration: "none",
              fontSize: "12px", fontWeight: "600", fontFamily: "inherit",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.14)"; e.currentTarget.style.color = "white"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.07)"; e.currentTarget.style.color = "rgba(255,255,255,0.75)"; }}
          >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
              <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/>
            </svg>
            Visit ecoconnectservices.com
          </a>

          <div style={{ display: "flex", gap: "12px", marginTop: "4px" }}>

            {/* LinkedIn */}
            <a href="https://www.linkedin.com/company/ecoconnect-services/" target="_blank" rel="noreferrer"
              style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#0077b5", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s ease", color: "white", textDecoration: "none" }}
              onMouseEnter={(e) => { e.currentTarget.style.opacity = "0.85"; e.currentTarget.style.transform = "scale(1.1)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; e.currentTarget.style.transform = "scale(1)"; }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>

            {/* Instagram */}
            <a href="https://www.instagram.com/ecoconnect_official_/?hl=en" target="_blank" rel="noreferrer"
              style={{ width: "40px", height: "40px", borderRadius: "50%", background: "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s ease", color: "white", textDecoration: "none" }}
              onMouseEnter={(e) => { e.currentTarget.style.opacity = "0.85"; e.currentTarget.style.transform = "scale(1.1)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; e.currentTarget.style.transform = "scale(1)"; }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>

            {/* Facebook */}
            <a href="https://www.facebook.com/share/18NWtpP8Dp/" target="_blank" rel="noreferrer"
              style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#1877f2", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s ease", color: "white", textDecoration: "none" }}
              onMouseEnter={(e) => { e.currentTarget.style.opacity = "0.85"; e.currentTarget.style.transform = "scale(1.1)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; e.currentTarget.style.transform = "scale(1)"; }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>

            {/* X (Twitter) */}
            <a href="https://x.com/Ecoconnect_512" target="_blank" rel="noreferrer"
              style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#000000", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s ease", color: "white", textDecoration: "none" }}
              onMouseEnter={(e) => { e.currentTarget.style.opacity = "0.85"; e.currentTarget.style.transform = "scale(1.1)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; e.currentTarget.style.transform = "scale(1)"; }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.259 5.631 5.905-5.631zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>

          </div>
        </div>

        <div className="footer-col">
          <h4>Platform</h4>
          <Link to="/platform">How It Works</Link>
          <Link to="/platform">For Entrepreneurs</Link>
          <Link to="/platform">For Vendors</Link>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <Link to="/contact">Contact Us</Link>
          <Link to="/contact">About Ecoconnect</Link>
          <Link to="/contact">Careers</Link>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2026 Ecoconnect Services. All rights reserved.</p>
        <p>Privacy Policy · Terms of Use · Sitemap</p>
      </div>
    </footer>
  );
}

export default Footer;